import { createStore } from 'framework7';
import { http } from '../api/config.js';

const carAppointments = createStore({
  state: {
    item: {},
    list: [],
  },
  actions: {
//Mutations
    set_item({ state }, item) {
      state.item = item;
    },
//End mutations

    async getLoanAppointmentItemToDeliver({ dispatch }, carLoanId) {
      let response = [];
      let result = {};

      result = await http.get(`loan/appointment/deliver/${carLoanId}`);
      if (result.status === 200) {
        response = result.data;
        return response;
      }
      else {
        return result;
      }
    },
    async getLoanAppointmentItemToReturn({ dispatch }, carLoanId) {
      let response = [];
      let result = {};

      result = await http.get(`loan/appointment/return/${carLoanId}`);
      if (result.status === 200) {
        response = result.data;
        return response;
      }
      else {
        return result;
      }
    },
  },
  getters: {
    Item({ state }) {
      return state.item;
    }
  },
});

export default carAppointments;
